"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Anchor = _interopRequireDefault(require("../Anchor"));
var _Text = _interopRequireDefault(require("../Text"));
var _Grid = _interopRequireDefault(require("../Grid"));
var _theme = _interopRequireDefault(require("../../theme"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrustBox__Wrapper",
  componentId: "sc-3cla3d-0"
})(["grid-column:1 / 13;", ""], _theme["default"].mediaMediumPlus(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n     display: flex;\n     justify-content: space-between;\n  "]))));
var TrustPilotWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrustBox__TrustPilotWrapper",
  componentId: "sc-3cla3d-1"
})(["height:60px;", " ", " iframe{height:100%;}"], _theme["default"].mediaMediumPlus(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n     height: 40px;\n     width: 190px;\n  "]))), _theme["default"].mediaLargePlus(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n     height: 20px;\n     width: 420px;\n  "]))));
var FinancialConductAuthorityWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrustBox__FinancialConductAuthorityWrapper",
  componentId: "sc-3cla3d-2"
})(["text-align:center;", " ", ""], _theme["default"].mediaMediumPlus(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n     text-align: right;\n  "]))), _theme["default"].mediaLargePlus(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n     display: flex;\n     margin-top: 3px;\n  "]))));
var TrustBox = /*#__PURE__*/function (_PureComponent) {
  _inherits(TrustBox, _PureComponent);
  var _super = _createSuper(TrustBox);
  function TrustBox() {
    var _this;
    _classCallCheck(this, TrustBox);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "retriesLeft", 99);
    return _this;
  }
  _createClass(TrustBox, [{
    key: "injectScriptOnce",
    value: function injectScriptOnce() {
      // bail if script exists, or has already run
      if (document.getElementById('trustpilot-script') || window.Trustpilot) {
        return;
      }
      // create fragment; append to body
      var script = document.createElement('script');
      script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      script.id = 'trustpilot-script';
      document.body.appendChild(script);
    }
  }, {
    key: "runScriptWhenLoaded",
    value: function runScriptWhenLoaded() {
      var _this2 = this;
      var widgetId = this.props.widgetId;
      // check every 50ms until script has loaded, or we give up after 99 tries
      var checkScriptLoaded = setInterval(function () {
        if (window.Trustpilot || !_this2.retriesLeft) {
          clearInterval(checkScriptLoaded);
          // run script
          window.Trustpilot && window.Trustpilot.loadFromElement(document.querySelector("#".concat(widgetId)));
        }
        _this2.retriesLeft--;
      }, 50);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.injectScriptOnce();
      this.runScriptWhenLoaded();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        theme = _this$props.theme,
        widgetId = _this$props.widgetId;
      var color = theme === 'dark' ? 'white' : 'dark';
      return /*#__PURE__*/_react["default"].createElement(_Grid["default"], null, /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(TrustPilotWrapper, {
        id: widgetId,
        "data-locale": "en-GB",
        "data-template-id": "5419b6ffb0d04a076446a9af",
        "data-businessunit-id": "4ecbc5d70000640005119c22",
        "data-style-width": "100%",
        "data-theme": theme
      }, /*#__PURE__*/_react["default"].createElement(_Anchor["default"], {
        href: "https://uk.trustpilot.com/review/www.totallymoney.com",
        target: "_blank",
        rel: "noopener",
        color: color
      }, "Trustpilot")), /*#__PURE__*/_react["default"].createElement(FinancialConductAuthorityWrapper, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        variant: "80",
        color: color
      }, "Financial Conduct Authority\xA0"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        variant: "80",
        color: color,
        weight: "bold"
      }, "Authorised & Regulated"))));
    }
  }]);
  return TrustBox;
}(_react.PureComponent);
_defineProperty(TrustBox, "propTypes", {
  /**
   * Defines the color of text we should show
   */
  theme: _propTypes["default"].oneOf(['light', 'dark']),
  /**
   * Defines the widget ID (only used with multiple widget instances)
   */
  widgetId: _propTypes["default"].string
});
_defineProperty(TrustBox, "defaultProps", {
  theme: 'light',
  widgetId: 'trustpilot-widget'
});
var _default = exports["default"] = TrustBox;